module.exports = __webpack_public_path__ + "static/media/video-9.57f6f1fd.jpg";